import { Alert, AlertTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ContactsSupport } from '../../components/ContactsSupport';

export const BankConnectionForNonEnterprise = () => {
  const { t } = useTranslation('bank-connection');
  return (
    <Alert severity={'warning'} sx={{ p: 4, backgroundColor: 'background.paper' }} variant={'outlined'}>
      <AlertTitle>{t('nonEnterprise.title')}</AlertTitle>
      <Typography variant={'subtitle1'} whiteSpace={'break-spaces'}>
        {t('nonEnterprise.description')}
      </Typography>
      <ContactsSupport sx={{ mt: 4 }} />
    </Alert>
  );
};
